export const MUTATION_SET_COMPOSITION = 'MUTATION_SET_COMPOSITION';
export const MUTATION_UPDATE_SIDE_CONTENT = 'MUTATION_UPDATE_SIDE_CONTENT';
export const MUTATION_ORDER_DATA = 'MUTATION_ORDER_DATA';
export const MUTATION_UPDATE_SIDE_PRINTSTYLE =
  'MUTATION_UPDATE_SIDE_PRINTSTYLE';
export const MUTATION_DELETE_SIDE = 'MUTATION_DELETE_SIDE';
export const MUTATION_ADD_SIDE = 'MUTATION_ADD_SIDE';

import { NAMESPACE } from './namespace';
export const MUTATION_COMPOSITION_SET_COMPOSITION = `${NAMESPACE}${MUTATION_SET_COMPOSITION}`;
export const MUTATION_COMPOSITION_UPDATE_SIDE_CONTENT = `${NAMESPACE}${MUTATION_UPDATE_SIDE_CONTENT}`;
export const MUTATION_COMPOSITION_ORDER_DATA = `${NAMESPACE}${MUTATION_ORDER_DATA}`;
export const MUTATION_COMPOSITION_UPDATE_SIDE_PRINTSTYLE = `${NAMESPACE}${MUTATION_UPDATE_SIDE_PRINTSTYLE}`;
